import { axiosClient } from '@nx-frontend/shared/api';
import { GroupInclusion } from '@nx-frontend/shared/types';

export async function clientGetBucketGroupInclusions(bucketId: string): Promise<GroupInclusion[]> {
  if (!bucketId) return [];
  try {
    const response = await axiosClient.get<GroupInclusion[]>(`/v2/api/bucket/${bucketId}/groupinclusions`);
    return response.data;
  } catch (err) {
    console.log(`clientGetBucketGroupInclusions error: ${err}`);
  }
  return [];
}
